import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { applyFlagParam, resolveEnabledFlags } from '@/lib/feature-flags';

export default function useFeatureFlag(name: string): boolean {
  const [searchParams] = useSearchParams();
  const flagParam = searchParams.getAll('flag').join(',');

  // Persist whatever the URL asked for, so the flag survives later navigation.
  useEffect(() => {
    if (flagParam) applyFlagParam(flagParam);
  }, [flagParam]);

  return useMemo(() => resolveEnabledFlags(flagParam).has(name), [flagParam, name]);
}
